import { Config, createConfig, fallback, http } from 'wagmi';
import { base, baseSepolia, mainnet, sepolia } from 'wagmi/chains';

const ALCHEMY_API_KEY = process.env.NEXT_PUBLIC_ALCHEMY_API_KEY as string;

/**
 * Creates a transport configuration for a given chain.
 * @function createTransport
 * @param {string} chain - The chain name.
 * @returns {ReturnType<typeof fallback>} The transport configuration.
 */
const createTransport = (chain: string) =>
  fallback([
    http(`https://${chain}.g.alchemy.com/v2/${ALCHEMY_API_KEY}`),
    http(),
  ]);

/**
 * WAGMI configuration for connecting to Ethereum and Base chains.
 * @constant {Config} wagmiConfig - The WAGMI configuration object.
 */
export const wagmiConfig: Config = createConfig({
  chains:
    process.env.NEXT_PUBLIC_APP_ENV === 'production'
      ? [mainnet, base]
      : [sepolia, baseSepolia],
  multiInjectedProviderDiscovery: false,
  ssr: true,
  transports: {
    [mainnet.id]: createTransport('eth-mainnet'),
    [base.id]: createTransport('base-mainnet'),
    [sepolia.id]: createTransport('eth-sepolia'),
    [baseSepolia.id]: createTransport('base-sepolia'),
  },
});

declare module 'wagmi' {
  interface Register {
    config: typeof wagmiConfig;
  }
}
